module.exports = __webpack_public_path__ + "img/plus_btn.92da8b6f.png";